import React, { memo } from 'react';
import { BsDot } from 'react-icons/bs';
import { formatCpfCnpj } from '@utils/formatters';
import { Tooltip } from 'antd';
import { ICustomerContextOption } from '../selectContext.types';

import * as S from './styles';

const SelectContextItem = ({
  id,
  name,
  tradingName,
  cnpj,
}: ICustomerContextOption) => (
  <Tooltip title={name || tradingName} mouseEnterDelay={0.6}>
    <S.SelectContextItemContainer>
      <S.SelectContextItemTitle>{name?.toUpperCase()}</S.SelectContextItemTitle>
      <S.SelectContextItemContent>
        <span>
          {id}
          <BsDot />
        </span>
        <span>{cnpj && formatCpfCnpj(cnpj)}</span>
        {tradingName && tradingName !== name && (
          <span>
            {cnpj && <BsDot />}
            {tradingName}
          </span>
        )}
      </S.SelectContextItemContent>
    </S.SelectContextItemContainer>
  </Tooltip>
);

export default memo(SelectContextItem);
